module.exports = __webpack_public_path__ + "static/media/05C.4d7ddf94.png";